import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';

// Keyword slots — first match in allProducts wins for each slot
const DEAL_SLOTS = [
  {
    label: 'Smartwatch',
    badge: '⌚',
    keywords: ['galaxy watch', 'apple watch', 'smart watch', 'smartwatch', 'huawei watch', 'wearable', 'fitness watch', 'watch'],
  },
  {
    label: 'Samsung Phone',
    badge: '📱',
    keywords: ['samsung galaxy s', 'galaxy s2', 'galaxy a', 'samsung galaxy', 'galaxy fold', 'galaxy flip', 'samsung phone'],
  },
  {
    label: 'iPhone',
    badge: '📱',
    keywords: ['iphone 16', 'iphone 15', 'iphone 14', 'iphone 13', 'iphone 12', 'iphone'],
  },
  {
    label: 'Headphones',
    badge: '🎧',
    keywords: ['airpods max', 'headphone', 'over-ear', 'on-ear', 'headset', 'earphone', 'airpods', 'buds', 'earbuds'],
  },
  {
    label: 'Laptop',
    badge: '💻',
    keywords: ['macbook', 'thinkpad', 'elitebook', 'xps', 'inspiron', 'ideapad', 'vivobook', 'zenbook', 'laptop', 'notebook'],
  },
];

function DealsStrip({ allProducts }) {
  const dealProducts = useMemo(() => {
    if (!allProducts || allProducts.length === 0) return [];
    const used = new Set();
    return DEAL_SLOTS.map(slot => {
      for (const kw of slot.keywords) {
        const match = allProducts.find(
          p => !used.has(p.id) && p.name.toLowerCase().includes(kw.toLowerCase())
        );
        if (match) {
          used.add(match.id);
          return { ...match, _slotLabel: slot.label, _badge: slot.badge };
        }
      }
      return null;
    }).filter(Boolean);
  }, [allProducts]);

  if (dealProducts.length === 0) return null;

  return (
    <section className="deals-strip-outer" aria-label="Products on Offer">
      <div className="deals-strip-outer-header">
        <span className="deals-strip-eyebrow">Our Picks</span>
        <span className="deals-strip-tag">Today's selection</span>
      </div>

      <div className="deals-strip-section">
        <div className="deals-strip-header">
          <h2 className="deals-strip-title">Products on Offer</h2>
        </div>

        <div className="deals-strip-grid">
          {dealProducts.map(product => {
            const img = product.image1 || product.image2 || product.image3 || null;
            return (
              <Link
                key={product.id}
                to={`/product/${product.slug || product.id}`}
                className="deal-card"
              aria-label={`${product.name} — KES ${parseFloat(product.price).toLocaleString('en-KE')}`}
            >
              <div className="deal-card-img-wrap">
                {img
                  ? <img src={img} alt={product.name} loading="lazy" className="deal-card-img" />
                  : <div className="deal-card-no-img" />
                }
                <span className="deal-card-badge">{product._slotLabel}</span>
              </div>
              <div className="deal-card-info">
                <p className="deal-card-name">{product.name}</p>
                <p className="deal-card-price">
                  KES {parseFloat(product.price).toLocaleString('en-KE', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </p>
                <span className="deal-card-cta">Shop Now →</span>
              </div>
            </Link>
          );
        })}
        </div>
      </div>
    </section>
  );
}

export default DealsStrip;
